// extracted by mini-css-extract-plugin
export default {"wheel":"vp_o_khP","dragger":"vp_GrsHt","spinner":"vp_OmCoe","line":"vp_uVHED","button":"vp_cCvh7"};